import { render } from "./Router.App.vue?vue&type=template&id=2d076e95"
import script from "./Router.App.vue?vue&type=script&lang=js"
export * from "./Router.App.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__